var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import PublicRequester from "@/api/RequestAxios/RequestAxiosHubPublic";
import { packQueryParams, stringifyQueryParams } from "../utils";
import { UIModelChannel, UIModelChannels } from "./channels.model";
import { packChannel, unpackChannels, unpackChannel, packChannelConsents, packUpdateBillingFinish, packUpdateBillingStart, unpackWaba, unpackMigrateChannel, unpackPermissions, unpackPermissionsList, unpackProfile, packAdminChannel, unpackUpdatedCommerceSettings } from "./channels.mapper";
import { MixpanelEvents } from "@/utilities/mixpanel/events";
var channelsURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels");
};
var channelURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId);
};
var partnerChannelURL = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId);
};
var channelsSubmitURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/submit");
};
var submitMigrationUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/submit_migration");
};
var migrateChannelUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/migrate_channel");
};
var requestVerificationUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/request_migration_code");
};
var verifyMigrationUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/verify_migration");
};
var channelsUpdateStatusURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/update_status");
};
var channelsUpdatePhoneNameURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/request_new_name");
};
var channelsUpdateDeclinedPhoneNameURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/update_name");
};
var channelsUpdateConsents = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/update_consents");
};
var channelsDeleteConsents = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/delete_consents");
};
var channelsWabaRegistrationURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/send_register_reminder");
};
var channelsAddNumberUrl = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, wabaAccountId = _a.wabaAccountId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/waba_accounts/").concat(wabaAccountId, "/control/add_number");
};
var requestCodeURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/request_number_verification_code");
};
var verifyCodeURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/verify_number_verification_code");
};
var integrationUrl = function (_a) {
    var integrationId = _a.integrationId;
    return "/partners/waba_setup/".concat(integrationId);
};
var channelConsentsGetDataUrl = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/info/client");
};
var channelConsentsUpdateDataUrl = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId, token = _a.token;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/control/update_info?token=").concat(token);
};
var channelConsentsUpdateConsentsUrl = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId, token = _a.token;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/control/sign_consents?token=").concat(token);
};
var channelAvailabilityURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/set_availability");
};
var channelSetVerifiedURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/set_verified");
};
var channelUpdateBillingFinishURL = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/control/update_billing_finish_date");
};
var channelUpdateBillingStartURL = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/control/update_billing_start_date");
};
var channelDeleteNumberURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/cancellation_request");
};
var revokeNumberDeletionURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/revoke_cancellation");
};
var getProfileURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/profile_settings");
};
var uploadProfilePhotoURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/upload_profile_photo");
};
var channelsPermissionsURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/api-key-permission");
};
var getPermissionsListURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/clients-shared-numbers");
};
var changeInboxSettingURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/inbox_settings");
};
var togglePremiumStatusURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId;
    return "/payment_provider/partners/".concat(partnerId, "/clients/").concat(clientId, "/channels/").concat(channelId, "/toggle_premium");
};
var getCurrentPriceURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId;
    return "/payment_provider/partners/".concat(partnerId, "/clients/").concat(clientId, "/channels/").concat(channelId, "/current_price");
};
var migrateToCloudApiURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/migrate_to_cloud_api");
};
var getWhatsAppCommerceSettingsURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/whatsapp_commerce_settings");
};
var setPricingTierURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/set_price_tier");
};
var onPremiseMigrationURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/migrate_to_on_premise");
};
var webhookUrl = function () { return "/configs/webhook"; };
export var getChannelsList = function (_a, queryParams) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(channelsURL({ partnerId: partnerId, clientId: clientId, projectId: projectId }), {
                        params: queryParams && packQueryParams(queryParams),
                        paramsSerializer: stringifyQueryParams
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelChannels(unpackChannels(data))];
            }
        });
    });
};
export var getChannel = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(channelURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, new UIModelChannel(unpackChannel(fullResponse))];
            }
        });
    });
};
export var addChannel = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsURL({ partnerId: partnerId, clientId: clientId, projectId: projectId }), packChannel(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelChannel(unpackChannel(data))];
            }
        });
    });
};
export var editChannel = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(channelURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }), packChannel(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var adminEditChannel = function (_a, payload) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(partnerChannelURL({ partnerId: partnerId, channelId: channelId }), packAdminChannel(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var deleteChannel = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.delete(channelURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var submitChannel = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsSubmitURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var addNumberChannel = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, wabaAccountId = _a.wabaAccountId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsAddNumberUrl({
                        partnerId: partnerId,
                        clientId: clientId,
                        wabaAccountId: wabaAccountId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var requestCode = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(requestCodeURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var verifyCode = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(verifyCodeURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updateStatusChannel = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsUpdateStatusURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var channelsWabaRegistration = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsWabaRegistrationURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updatePhoneName = function (_a, phoneName) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsUpdatePhoneNameURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), { phone_name: phoneName })];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var updateDeclinedPhoneName = function (_a, phoneName) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsUpdateDeclinedPhoneNameURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), { phone_name: phoneName })];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var updateConsents = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsUpdateConsents({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), packChannelConsents(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var deleteConsents = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsDeleteConsents({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), {})];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
var channelGetOrNotIntegration = function (data) { return __awaiter(void 0, void 0, Promise, function () {
    var response, integrationId, integration, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                response = data;
                integrationId = data.integration_id;
                if (!(integrationId && !data.integration)) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getIntegration({ integrationId: integrationId })];
            case 2:
                integration = _a.sent();
                response = __assign(__assign({}, data), { integration: integration });
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                MixpanelEvents.errorEvent("Loading integration error");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, response];
        }
    });
}); };
export var getIntegration = function (_a) {
    var integrationId = _a.integrationId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(integrationUrl({ integrationId: integrationId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getChannelConsentsClientData = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId, token = _a.token;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, PublicRequester.requester.get(channelConsentsGetDataUrl({ partnerId: partnerId, channelId: channelId }), {
                        params: { token: token }
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updateChannelConsentsClientData = function (_a, body) {
    var partnerId = _a.partnerId, channelId = _a.channelId, token = _a.token;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, PublicRequester.requester.post(channelConsentsUpdateDataUrl({ partnerId: partnerId, channelId: channelId, token: token }), body)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updateChannelConsents = function (_a, body) {
    var partnerId = _a.partnerId, channelId = _a.channelId, token = _a.token;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, PublicRequester.requester.post(channelConsentsUpdateConsentsUrl({ partnerId: partnerId, channelId: channelId, token: token }), body)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var setChannelAvailability = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelAvailabilityURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var setChannelVerified = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelSetVerifiedURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var updateBillingFinish = function (_a, payload) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelUpdateBillingFinishURL({
                        partnerId: partnerId,
                        channelId: channelId
                    }), packUpdateBillingFinish(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var updateBillingStart = function (_a, payload) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelUpdateBillingStartURL({
                        partnerId: partnerId,
                        channelId: channelId
                    }), packUpdateBillingStart(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var deleteNumber = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelDeleteNumberURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackChannel(data)];
            }
        });
    });
};
export var revokeNumberDeletion = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(revokeNumberDeletionURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getProfile = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getProfileURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackProfile(data)];
            }
        });
    });
};
export var editWaba = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(getProfileURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackWaba(fullResponse)];
            }
        });
    });
};
export var uploadProfilePhoto = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(uploadProfilePhotoURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }), payload.file, {
                        headers: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: payload.onUploadProgress
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.profile_info.picture_url];
            }
        });
    });
};
export var submitMigration = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(submitMigrationUrl({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), {})];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var verifyMigration = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(verifyMigrationUrl({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var requestVerification = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, fullResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(requestVerificationUrl({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, channelGetOrNotIntegration(data)];
                case 2:
                    fullResponse = _b.sent();
                    return [2 /*return*/, unpackChannel(fullResponse)];
            }
        });
    });
};
export var migrateChannel = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(migrateChannelUrl({
                        partnerId: partnerId,
                        clientId: clientId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackMigrateChannel(data)];
            }
        });
    });
};
export var grantPermissions = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(channelsPermissionsURL({
                        partnerId: partnerId,
                        clientId: clientId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPermissions(data)];
            }
        });
    });
};
export var getPermissionsList = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPermissionsListURL({
                        partnerId: partnerId,
                        clientId: clientId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, Array.isArray(data)
                            ? data === null || data === void 0 ? void 0 : data.map(function (item) { return unpackPermissionsList(item); })
                            : []];
            }
        });
    });
};
export var changeInboxSettings = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(changeInboxSettingURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var togglePremiumStatus = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(togglePremiumStatusURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        channelId: channelId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getCurrentPrice = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, currency, unitAmount;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getCurrentPriceURL({ partnerId: partnerId, clientId: clientId, channelId: channelId }))];
                case 1:
                    data = (_b.sent()).data;
                    currency = data.currency, unitAmount = data.unit_amount;
                    return [2 /*return*/, {
                            currency: currency,
                            unitAmount: unitAmount
                        }];
            }
        });
    });
};
export var migrateChannelToCloudAPI = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(migrateToCloudApiURL({ partnerId: partnerId, clientId: clientId, projectId: projectId, channelId: channelId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getWhatsAppCommerceSettings = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, commerceData, id, isCartEnabled, isCatalogVisible;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getWhatsAppCommerceSettingsURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        channelId: channelId,
                        projectId: projectId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    if (data.data.length <= 0) {
                        return [2 /*return*/, {
                                id: null,
                                isCartEnabled: false,
                                isCatalogVisible: false
                            }];
                    }
                    commerceData = data.data[0];
                    id = commerceData.id, isCartEnabled = commerceData.is_cart_enabled, isCatalogVisible = commerceData.is_catalog_visible;
                    return [2 /*return*/, {
                            id: id,
                            isCartEnabled: isCartEnabled,
                            isCatalogVisible: isCatalogVisible
                        }];
            }
        });
    });
};
export var updateWhatsAppCommerceSettings = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(getWhatsAppCommerceSettingsURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        channelId: channelId,
                        projectId: projectId
                    }), {
                        is_cart_enabled: payload.isCartEnabled,
                        is_catalog_visible: payload.isCatalogVisible
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackUpdatedCommerceSettings(data)];
            }
        });
    });
};
export var setPricingTier = function (_a, payload) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.id, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(setPricingTierURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        channelId: channelId,
                        projectId: projectId
                    }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackUpdatedCommerceSettings(data)];
            }
        });
    });
};
export var migrateChannelToOnPremiseAPI = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelId = _a.channelId, projectId = _a.projectId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(onPremiseMigrationURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        channelId: channelId,
                        projectId: projectId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var setChannelWebhook = function (_a) {
    var url = _a.url, apiKey = _a.apiKey;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.wabaConfig.post(webhookUrl(), {}, {
                        headers: {
                            "D360-API-KEY": apiKey,
                            "Content-Type": "application/json"
                        }
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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